import { render, staticRenderFns } from "./TokenManagementLiquidityPoolTab.vue?vue&type=template&id=c2e052d4&scoped=true&lang=pug"
import script from "./TokenManagementLiquidityPoolTab.vue?vue&type=script&lang=ts"
export * from "./TokenManagementLiquidityPoolTab.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementLiquidityPoolTab.vue?vue&type=style&index=0&id=c2e052d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e052d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VRow,VSpacer})
